import { render, staticRenderFns } from "./UiSettings.vue?vue&type=template&id=9c51cce2&scoped=true"
import script from "./UiSettings.vue?vue&type=script&lang=js"
export * from "./UiSettings.vue?vue&type=script&lang=js"
import style0 from "./UiSettings.vue?vue&type=style&index=0&id=9c51cce2&prod&lang=scss&scoped=true"
import style1 from "./UiSettings.vue?vue&type=style&index=1&id=9c51cce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c51cce2",
  null
  
)

export default component.exports